import axiosInstance from "@/axiosInstance";

const state = () => ({
    branches: [],
    onboardLoaded: false,
});

const mutations = {
  SET_BRANCHES(state, branches) {
      state.branches = branches;
  },
  SET_BRANCHES_LOADED(state, loaded) {
      state.branchesLoaded = loaded;
  },
  CLEAR_BRANCHES_DATA(state) {
      state.branches = [];
      state.branchesLoaded = false;
  },
};

const actions = {
  async fetchBranchesData({ state, commit }) {
    if (state.branchesLoaded) return;
    try {
      const [branchRes] = await Promise.all([
        axiosInstance.get("branches/"),
      ]);
      commit("SET_BRANCHES", branchRes.data);
      commit("SET_BRANCHES_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch onboard data:", error);
    }
  },
  // async fetchPositionInfo(_, slug) {
  //     try {
  //         const response = await axiosInstance.get(`onboard/positions/${slug}/`);
  //         return response.data;
  //     } catch (error) {
  //         console.error("Failed to fetch position by slug:", error);
  //         throw error;
  //     }
  // }
};

const getters = {
  getBranches: (state) => state.branches,
  isBranchesLoaded: (state) => state.branchesLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};


